import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const attendanceApi = createApi({
  reducerPath: "attendanceApi",

  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Attendance/`),

  endpoints: (builder) => ({
    getAllAttendance: builder.query({
      query: () => ({
        url: "GetAllAttendances",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllAttendanceQuery,
} = attendanceApi;

export default attendanceApi.reducer;
